<template>
  <div class="container-fluid my-3 record" style="min-height:50vh">
    <div class="row">
      <div class="col-12 ">
        <div class="d-flex title-box">
          <div class="title" :class="{'active': currentPage==='Record'}" @click="goPage('Record')">詳細內容</div>
          <div class="title" :class="{'active': currentPage==='LineChart'}" @click="goPage('LineChart')">學習曲線</div>
        </div>
        <!-- <div  class="my-2" v-if="currentPage==='LineChart'">
          日期區間:
        <date-picker valueType="format" v-model="range" type="date" range placeholder="請選擇日期區間"></date-picker>
        </div> -->
      </div>
    </div>
    <div class="layout">
      <div v-if="currentPage=='Record'">
        <div class="col-12" style="min-height:40vh">
          <div class="d-flex" v-for="(item, index) in recordInfo" :key="index">
            <table class="rwd-table" >
              <tbody>
                <tr>
                  <th class="th-title" style="text-align:center; width:350px!important;background-size:cover;" rowspan="2" :style="{ backgroundImage: 'url(' + item.banner + ')' }">
                    <div>
                      {{item.level1}} > {{item.level2}}
                    </div>
                    <h5>{{item.name}}</h5>
                  </th>
                  <th>最近學習時間</th>
                  <th>學習時數</th>
                  <th>第一次分數</th>
                  <th>口說分數</th>
                  <th>學習次數</th>
                </tr>
                <tr>
                  <td class="rwd-td" style="display:none" data-th="回數">
                    {{item.name}}
                  </td>
                  <td data-th="最近學習時間">
                    {{moment(item.recent).format('YYYY/MM/DD HH:mm:ss') }}
                  </td>
                  <td data-th="學習時數">
                    {{item.time}}
                  </td>
                  <td data-th="第一次分數">
                    {{item.first_speak_score}}
                  </td>
                  <td v-if="item.speak === 'N/A'" data-th="口說分數"  style="color:#8d8d8d" >
                    {{item.speak}}
                  </td>
                  <td v-else data-th="口說分數" style="text-decoration: underline;" class="pointer" @click="goVoice(item.id)">
                    {{item.speak}}
                  </td>
                  <td data-th="學習次數">
                    {{item.finish_speak_count}}
                  </td>
                </tr>
              </tbody>
            </table>
            <button type="button" style="width:100px" class="btn btn-danger m-1" @click="goLesson(item.id)">前往課程</button>
          </div>
          <pagination
            v-if="pageCount > 1 && recordInfo && recordInfo.length > 0"
            class="m-auto pt-4"
            :current="pageIndex"
            :total="pageCount"
            v-on:page="toPage"
          />
        </div>
      </div>

      <div v-if="currentPage=='LineChart'">
        <div class="col-12" style="min-height:40vh">
          <div style="margin:100px" v-if="datasets">
            <LineChart :height="250" :datasets="datasets" class="mt-3 m-auto" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import DatePicker from 'vue2-datepicker'
import LineChart from './LineChart.vue'
import Pagination from './Pagination.vue'
import 'vue2-datepicker/index.css'
import api from '../store/api'
export default {
  name: 'Record',
  data () {
    return {
      personalData: {},
      currentPage: 'Record',
      recordInfo: null,
      lessonList: [],
      range: [],
      datasets: null,
      pageIndex: 1,
      pageCount: 0,
      pageSize: 10
    }
  },
  components: {
    Pagination,
    LineChart,
    DatePicker
  },
  mounted () {
    this.getRange()
    this.getPersonalData()
    this.getRecordInfo()
  },
  methods: {
    goPage (el) {
      this.currentPage = el
      this.getPersonalData()
      if (el === 'Record') {
        this.pageIndex = 1
        this.getRecordInfo()
      } else if (el === 'LineChart') {
        this.getCurveData()
      }
    },
    async getPersonalData () {
      this.personalData = this.$store.state.auth.personalData
    },
    async getRange () {
      const self = this
      this.range = [self.moment(this.$store.state.auth.user.group_begin_at).format('YYYY-MM-DD'), self.moment(this.$store.state.auth.user.group_end_at).format('YYYY-MM-DD')]
    },
    async getCurveData() {
      const { data } = await api.get(`me/speak_growing_avg`)
      const date = Object.values(data.data).map(item => item.date)
      const score = Object.values(data.data).map(item => item.score)
      this.datasets = {
        labels: date,
        datasets: [
          {
            label: '',
            borderColor: '#f87979',
            data: score,
            fill: false
          }
        ]
      }
    },
    async getRecordInfo () {
      const params = {
        page: this.pageIndex,
        pageSize: this.pageSize,
        // categoryId: this.selectedChannel,
      }
      const { data } = await api.get('/records/courses', { params })
      this.recordInfo = data.data
      this.pageCount = data.pageCount
      this.pageIndex = data.pageIndex
    },
    toPage (toPage) {
      this.pageIndex = toPage
      this.getRecordInfo()
    },
    async getLessonId (id) {
      const { data } = await api.get(`/contents/courses/${id}`)
      if (data.status === 'Success') {
        return data.data
      }
    },
    async goLesson (id) {
      const self = this
      await this.getLessonId(id).then((val) => {
        this.$router.push({ name: 'CourseLesson', params: { lesson: val.id, groupId: self.personalData.group_id, studentId: self.personalData.student_id ,courseId: val.sections[0].data.view_id||val.sections[0].id } })
      } )
    },
    goVoice (id) {
      this.$router.push({ name: 'PersonalVoiceRecord', params: { groupId: this.personalData.group_id, lessonId: id, studentId: this.personalData.student_id } })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/color.scss";
.record {
  text-align: left;
  .layout {
    min-height: 50vh;
  }
}
table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    border: 4px solid #fff;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }
  .th-title {
    width: 220px;
    height: 120px;
    padding: 0 !important;
    position: relative;
    img {
      top:0;
      left: -5px;
      position: absolute;
      width: 105%;
      height: 100%;
    }
  }
  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
  button  {
    display: none;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
